module.exports = __webpack_public_path__ + "img/bus.83214fba.svg";